interface SEOData {
  title?: string;
  description?: string;
  canonical?: string;
  ogUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogImageWidth?: number;
  ogImageHeight?: number;
  ogImageAlt?: string;
  ogType?: string;
  googlebot?: string;
  robots?: string;
  keywords?: string;
  author?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  twitterImageAlt?: string;
  twitterImageWidth?: number;
  twitterImageHeight?: number;
}

function setSEOMeta(seo: SEOData) {
  if (seo.title) document.title = seo.title;

  // Function to set or update meta
  const setMeta = (name: string, content: string, property = false) => {
    const attr = property ? 'property' : 'name';
    let meta = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attr, name);
      document.head.appendChild(meta);
    }
    meta.content = content;
  };

  const setLink = (rel: string, href: string) => {
    let link = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
  };

  if (seo.description) setMeta('description', seo.description);
  if (seo.canonical) setLink('canonical', seo.canonical);
  if (seo.ogUrl) setMeta('og:url', seo.ogUrl, true);
  if (seo.ogTitle) setMeta('og:title', seo.ogTitle, true);
  if (seo.ogDescription) setMeta('og:description', seo.ogDescription, true);
  if (seo.ogImage) setMeta('og:image', seo.ogImage, true);
  if (seo.ogImageWidth) setMeta('og:image:width', seo.ogImageWidth.toString(), true);
  if (seo.ogImageHeight) setMeta('og:image:height', seo.ogImageHeight.toString(), true);
  if (seo.ogImageAlt) setMeta('og:image:alt', seo.ogImageAlt, true);
  if (seo.ogType) setMeta('og:type', seo.ogType, true);
  if (seo.googlebot) setMeta('googlebot', seo.googlebot);
  if (seo.robots) setMeta('robots', seo.robots);
  if (seo.keywords) setMeta('keywords', seo.keywords);
  if (seo.author) setMeta('author', seo.author);
  if (seo.twitterCard) setMeta('twitter:card', seo.twitterCard);
  if (seo.twitterTitle) setMeta('twitter:title', seo.twitterTitle);
  if (seo.twitterDescription) setMeta('twitter:description', seo.twitterDescription);
  if (seo.twitterImage) setMeta('twitter:image', seo.twitterImage);
  if (seo.twitterImageAlt) setMeta('twitter:image:alt', seo.twitterImageAlt);
  if (seo.twitterImageWidth) setMeta('twitter:image:width', seo.twitterImageWidth.toString());
  if (seo.twitterImageHeight) setMeta('twitter:image:height', seo.twitterImageHeight.toString());
}

export { setSEOMeta, type SEOData };